export const tripCreateReducerSelector = state => state.tripCreateReducer;
export const selectedCitiesSelector = state => state.tripCreateReducer.selectedCities;
export const selectedStopsSelector = state => state.tripCreateReducer.selectedStops;
export const activeCitySelector = state => state.tripCreateReducer.activeCity;
export const activeStopsSelector = state => state.tripCreateReducer.activeStops;
export const scheduleSelector = state => state.tripCreateReducer.schedule;
export const standardStopsSelector = state => state.tripCreateReducer.standardAddressStops;
export const defaultIndexSelector = state => state.tripCreateReducer.defaultIndex;
